import { createElement } from 'react';
import Advanced from './Advanced';

const ContentLearningLibrary = ({ ...props }) => createElement(Advanced, props);

export default ContentLearningLibrary;
